<template>
  <div v-if="news">
    <h2>{{ news.title }}</h2>
    <div v-html="news.content"></div>
  </div>
</template>

<script>
import { getNewsDetail } from '@/api/cms'

export default {
  props: ['id'],
  data() {
    return {
      news: null
    }
  },
  created() {
    this.fetchDetail()
  },
  methods: {
    fetchDetail() {
      getNewsDetail(this.id).then(res => {
        this.news = res.data
      })
    }
  }
}
</script>